module.exports = __webpack_public_path__ + "static/media/btn_point_ztop_nor.10ec3ca1.svg";